import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuposycumulos-layout',
  templateUrl: './cuposycumulos-layout.component.html',
})
export class CuposycumulosLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
